import React from 'react'
import ServiceSyle from "./Services.module.css"

const Servicecs = () => {
  return (
    <div className={ServiceSyle.head}>
      <h1>Services</h1>
    </div>
  )
}

export default Servicecs
